import { render, staticRenderFns } from "./SiteTranslations.vue?vue&type=template&id=276cc701&scoped=true&"
import script from "./SiteTranslations.vue?vue&type=script&lang=js&"
export * from "./SiteTranslations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276cc701",
  null
  
)

export default component.exports